<div class="highlighted-background">
  <ng-content></ng-content>
</div>
